export default __webpack_public_path__ + "static/media/330_dummy2016-haushalthilfe01-de-mobile.334279d5.png";